<template lang="pug">
div.modal.fullfill.table(v-show="opened" @click="close")
    div.modal-content.table-cell
        div.container
            slot
</template>

<script>
export default {
    name: 'modal',
    data() { return { opened: false } },
    methods: {
        open: function() {
            this.opened = true;
            this.$emit('opened');
        },
        close: function() {
            this.opened = false;
            this.$emit('closed');
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~styles/mixins.scss';
.modal {
    z-index: 2000;
    background-color: rgba(0, 0, 0, 0.6);
    @include select-none();
    .modal-content {
        position: relative;
    }
}
</style>




// WEBPACK FOOTER //
// Modal.vue?118933e2